import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../interface_user/header/header";
import Footer from "../interface_user/footer/footer";
import Footer1 from "../interface_user/footer/footer1";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import {
  CheckOutlined,
  ClockCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  ProjectOutlined,
  UserOutlined,
  CalendarOutlined,
  DollarOutlined
} from "@ant-design/icons";
import { baseApiUrl } from "../../services/api";
import {
  Table,
  Modal,
  Button,
  notification,
  Input,
  Switch,
  Card,
  Row,
  Col,
  Statistic,
  Tag,
  Avatar,
  Steps,
  Divider,
  Space,
  Empty,
  Tooltip
} from "antd";

const { Step } = Steps;

function DetailProjets() {
  const [utilisateur, setUtilisateur] = useState(null);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [projets, setProjets] = useState([]);
  const [document, setDocument] = useState(null);
  const [image, setImage] = useState("");
  const [zoneExecution, setZoneExecution] = useState(null);
  const [impactEconomique, setImpactEconomique] = useState(null);
  const [impactSocial, setImpactSocial] = useState(null);
  const [impactEnvironnemental, setImpactEnvironnemental] = useState(null);
  const [selectedCategorie, setSelectedCategorie] = useState(null);
  const [video, setVideo] = useState("");
  const [calendrierFin, setCalendrierFin] = useState("");
  const [calendrierDebut, setCalendrierDebut] = useState("");
  const [budget, setBudget] = useState("");
  const [objectifs, setObjectifs] = useState("");
  const [beneficiaires, setBeneficiaires] = useState("");
  const [partenaires, setPartenaires] = useState("");
  const [step, setStep] = useState(1);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);

  const { profileId } = useParams();
  const [currentUser, setCurrentUser] = useState(null);

  // Récupérer les projets de l'utilisateur connecté
  const fetchProjets = async () => {
    if (!currentUser?.id) {
      console.warn("Utilisateur connecté introuvable, impossible de filtrer les projets.");
      return;
    }

    try {
      const response = await baseApiUrl.get("/projet/liste");
      console.log("Données reçues des projets :", response.data);

      const allProjets = Array.isArray(response.data) ? response.data : [];

      // Filtrer les projets en fonction de l'utilisateur connecté
      const userProjets = allProjets.filter(
        (projet) => projet.utilisateur?.id === currentUser.id
      );

      setProjets(userProjets);
      console.log("Projets de l'utilisateur connecté :", userProjets);
    } catch (error) {
      console.error("Erreur lors de la récupération des projets de l'utilisateur :", error);
    }
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const handleEdit = (projet) => {
    setViewingProjet(projet);
    setEditingProjet(projet);

    setTitre(projet.titre);
    setDescription(projet.description);
    setZoneExecution(projet.zoneExecution);
    setImpactEconomique(projet.impactEconomique);
    setImpactSocial(projet.impactSocial);
    setImpactEnvironnemental(projet.impactEnvironnemental);
    setSelectedCategorie(projet.categorieId);
    setImage(projet.image);
    setDocument(projet.document);
    setCalendrierDebut(projet.calendrierDebut);
    setCalendrierFin(projet.calendrierFin);
    setBudget(projet.budget);
    setObjectifs(projet.objectifs);
    setBeneficiaires(projet.beneficiaires);
    setPartenaires(projet.partenaires);
    setIsEditMode(true);
    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (projet) => {
    Modal.confirm({
      title: 'Êtes-vous sûr de vouloir supprimer ce projet ?',
      content: 'Cette action est irréversible.',
      okText: 'Oui, supprimer',
      cancelText: 'Annuler',
      onOk: () => handleDelete(projet.id),
    });
  };

  const handleDelete = async (projetId) => {
    try {
      await baseApiUrl.delete(`/projet/delete/${projetId}`);
      setProjets(projets.filter(projet => projet.id !== projetId));
      openNotificationWithIcon("success", "Projet supprimé avec succès.");
    } catch (error) {
      console.error("Erreur lors de la suppression du projet:", error);
      openNotificationWithIcon("error", "Erreur lors de la suppression du projet.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté:", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage.");
    }
  }, []);

  const handleNext = () => {
    setStep(step + 1);
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const handleEditProjet = async (e) => {
    e.preventDefault();

    if (!editingProjet) {
      openNotificationWithIcon("error", "Aucun projet sélectionné pour la modification.");
      return;
    }

    if (!titre) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    const projetData = {
      titre,
      description,
      categorieId: selectedCategorie,
      zoneExecution,
      impactEconomique,
      impactEnvironnemental,
      impactSocial,
      calendrierDebut,
      calendrierFin,
      budget,
      objectifs,
      beneficiaires,
      partenaires
    };

    const formData = new FormData();
    formData.append("projet", new Blob([JSON.stringify(projetData)], { type: "application/json" }));

    if (image) formData.append("image", image);
    if (document) formData.append("document", document);

    try {
      const response = await baseApiUrl.put(`/projet/update/${editingProjet.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedProjet = await response.data;
      console.log("Projet mis à jour:", updatedProjet);

      setProjets(
        projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet))
      );

      openNotificationWithIcon("success", "Projet modifié avec succès.");
      fetchProjets();
    } catch (error) {
      console.error("Erreur lors de la modification du projet:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
    }

    resetForm();
  };

  const truncateText = (text, wordLimit) => {
    if (typeof text !== "undefined" && text !== null) {
      const words = text.split(" ");
      if (words.length > wordLimit) {
        return words.slice(0, wordLimit).join(" ") + "...";
      }
      return text;
    } else {
      return "";
    }
  };

  const resetForm = () => {
    setStep(1);
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
    setTitre("");
    setDescription("");
    setSelectedCategorie("");
    setImage("");
    setDocument("");
    setZoneExecution("");
    setImpactEconomique("");
    setImpactEnvironnemental("");
    setImpactSocial("");
    setCalendrierDebut("");
    setCalendrierFin("");
    setBudget("");
    setObjectifs("");
    setBeneficiaires("");
    setPartenaires("");
  };

  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };

  useEffect(() => {
    if (profileId) {
      baseApiUrl
        .get(`/utilisateur/${profileId}`)
        .then((response) => {
          setUtilisateur(response.data);
          console.log("Utilisateur récupéré :", response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération de l'utilisateur :", error);
        });
    } else {
      console.error("L'ID du profil est introuvable !");
    }

    if (currentUser) {
      fetchProjets();
    }
  }, [profileId, currentUser]);

  useEffect(() => {
    if (currentUser) {
      fetchProjets();
    }
  }, [currentUser]);

  // Calculs des statistiques
  const totalProjets = projets.length;
  const projetsValides = projets.filter(p => p.actif).length;
  const projetsEnAttente = projets.filter(p => !p.actif).length;
  const budgetTotal = projets.reduce((sum, p) => sum + (parseFloat(p.budget) || 0), 0);

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      width: 80,
      render: (imageName) => {
        const imageUrl = baseApiUrl.defaults.baseURL + `/image/${imageName}`;
        return (
          <Avatar
            size={50}
            src={imageUrl}
            icon={<ProjectOutlined />}
            style={{ border: '2px solid #f0f0f0' }}
          />
        );
      },
    },
    {
      title: "Projet",
      key: "projet",
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
            {truncateText(record.titre, 4)}
          </div>
          <div style={{ color: '#666', fontSize: '12px' }}>
            {truncateText(record.description, 8)}
          </div>
        </div>
      ),
    },
    {
      title: "Budget",
      dataIndex: "budget",
      key: "budget",
      render: (budget) => (
        <div style={{ textAlign: 'center' }}>
          <DollarOutlined style={{ color: '#52c41a', marginRight: 4 }} />
          {budget ? `${parseInt(budget).toLocaleString()} FCFA` : "N/A"}
        </div>
      ),
    },
    {
      title: "Période",
      key: "periode",
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div><CalendarOutlined style={{ marginRight: 4 }} />Début: {record.calendrierDebut || 'N/A'}</div>
          <div style={{ marginTop: 2 }}>Fin: {record.calendrierFin || 'N/A'}</div>
        </div>
      ),
    },
    {
      title: "Statut",
      dataIndex: "actif",
      key: "statut",
      render: (actif) => (
        <Tag
          color={actif ? "success" : "warning"}
          icon={actif ? <CheckOutlined /> : <ClockCircleOutlined />}
        >
          {actif ? "Validé" : "En attente"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Voir les détails">
            <Button
              type="primary"
              ghost
              size="small"
              icon={<EyeOutlined />}
              onClick={() => {
                resetForm();
                handleView(record);
              }}
            />
          </Tooltip>

          {!record.actif && (
            <>
              <Tooltip title="Modifier">
                <Button
                  type="default"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={() => {
                    resetForm();
                    handleEdit(record);
                  }}
                />
              </Tooltip>
              <Tooltip title="Supprimer">
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteConfirm(record)}
                />
              </Tooltip>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Header />

      {/* Hero Section */}
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div className="container">
          <Row justify="center">
            <Col span={24} style={{ textAlign: 'center' }}>
              <h1 style={{ color: 'white', fontSize: '3rem', marginBottom: '1rem' }}>
                <ProjectOutlined style={{ marginRight: '1rem' }} />
                Mes Projets
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem' }}>
                Gérez et suivez vos projets en toute simplicité
              </p>
            </Col>
          </Row>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ padding: '60px 0', backgroundColor: '#f8f9fa' }}>
        <div className="container">

          {/* Profile & Statistics Section */}
          <Row gutter={[24, 24]} style={{ marginBottom: '40px' }}>
            {/* Profile Card */}
            <Col xs={24} lg={8}>
              <Card
                style={{
                  textAlign: 'center',
                  height: '100%',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}
              >
                <Avatar
                  size={100}
                  src={
                    currentUser && currentUser.photo
                      ? baseApiUrl.defaults.baseURL + `/image/${currentUser.photo}`
                      : undefined
                  }
                  icon={<UserOutlined />}
                  style={{ marginBottom: '16px', border: '4px solid #1890ff' }}
                />
                <h3 style={{ marginBottom: '8px' }}>
                  {currentUser?.nom} {currentUser?.prenom}
                </h3>
                <p style={{ color: '#666', marginBottom: '16px' }}>Porteur de projets</p>
                <Tag color="blue" style={{ fontSize: '12px' }}>
                  Profil actif
                </Tag>
              </Card>
            </Col>


          </Row>

          {/* Projects Table Section */}
          <Card
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                  <ProjectOutlined style={{ marginRight: '8px' }} />
                  Liste de mes projets
                </span>
                <Button
                  type="success"
                  icon={<PlusOutlined />}
                  size="large"
                  onClick={() => setIsAddModalVisible(true)}
                >
                  Nouveau Projet
                </Button>
              </div>
            }
            style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
          >
            {projets.length > 0 ? (
              <Table
                columns={columns}
                dataSource={projets}
                rowKey="id"
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} sur ${total} projets`,
                }}
                style={{ marginTop: '16px' }}
              />
            ) : (
              <Empty
                description="Aucun projet trouvé"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                style={{ margin: '40px 0' }}
              >
                <Button type="primary" icon={<PlusOutlined />}>
                  Créer mon premier projet
                </Button>
              </Empty>
            )}
          </Card>
        </div>
      </div>

      {/* Modal de modification */}
      <Modal
        title={
          <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            <EditOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            Modifier le projet
          </div>
        }
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        width={900}
        footer={null}
        style={{ top: 20 }}
      >
        <Steps current={step - 1} style={{ marginBottom: '30px' }}>
          <Step title="Informations générales" />
          <Step title="Impacts & Objectifs" />
          <Step title="Documents & Finalisation" />
        </Steps>

        <form onSubmit={handleEditProjet}>
          {step === 1 && (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Titre du projet *
                    </label>
                    <Input
                      size="large"
                      value={titre}
                      onChange={(e) => setTitre(e.target.value)}
                      placeholder="Entrez le titre du projet"
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Budget (FCFA) *
                    </label>
                    <Input
                      size="large"
                      type="number"
                      value={budget}
                      onChange={(e) => setBudget(e.target.value)}
                      placeholder="0"
                      prefix={<DollarOutlined />}
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Date de début
                    </label>
                    <Input
                      size="large"
                      type="date"
                      value={calendrierDebut}
                      onChange={(e) => setCalendrierDebut(e.target.value)}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Date de fin
                    </label>
                    <Input
                      size="large"
                      type="date"
                      value={calendrierFin}
                      onChange={(e) => setCalendrierFin(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={24}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Zone d'exécution
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={zoneExecution}
                      onChange={(e) => setZoneExecution(e.target.value)}
                      placeholder="Décrivez la zone géographique d'exécution du projet"
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={24}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Description du projet *
                    </label>
                    <Input.TextArea
                      rows={4}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Décrivez votre projet en détail"
                    />
                  </div>
                </Col>
              </Row>

              <div style={{ textAlign: 'right', marginTop: '24px' }}>
                <Button type="primary" size="large" onClick={handleNext}>
                  Suivant
                </Button>
              </div>
            </div>
          )}

          {step === 2 && (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Impact économique
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={impactEconomique}
                      onChange={(e) => setImpactEconomique(e.target.value)}
                      placeholder="Décrivez l'impact économique attendu"
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Impact environnemental
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={impactEnvironnemental}
                      onChange={(e) => setImpactEnvironnemental(e.target.value)}
                      placeholder="Décrivez l'impact environnemental"
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Impact social
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={impactSocial}
                      onChange={(e) => setImpactSocial(e.target.value)}
                      placeholder="Décrivez l'impact social du projet"
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Objectifs
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={objectifs}
                      onChange={(e) => setObjectifs(e.target.value)}
                      placeholder="Listez les objectifs principaux"
                    />
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Bénéficiaires
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={beneficiaires}
                      onChange={(e) => setBeneficiaires(e.target.value)}
                      placeholder="Qui sont les bénéficiaires du projet ?"
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Partenaires
                    </label>
                    <Input.TextArea
                      rows={3}
                      value={partenaires}
                      onChange={(e) => setPartenaires(e.target.value)}
                      placeholder="Listez vos partenaires"
                    />
                  </div>
                </Col>
              </Row>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
                <Button size="large" onClick={handlePrevious}>
                  Précédent
                </Button>
                <Button type="primary" size="large" onClick={handleNext}>
                  Suivant
                </Button>
              </div>
            </div>
          )}

          {step === 3 && (
            <div>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Domaine du projet
                    </label>
                    <select
                      className="form-control"
                      style={{ width: '100%', height: '40px', fontSize: '14px' }}
                      value={selectedCategorie}
                      onChange={(e) => setSelectedCategorie(Number(e.target.value))}
                    >
                      <option value="">Sélectionnez un domaine...</option>
                      {categoriesOptions.map((category) => (
                        <option key={category.value} value={category.value}>
                          {category.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Document du projet
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      style={{ width: '100%', height: '40px', padding: '8px' }}
                      onChange={(e) => setDocument(e.target.files[0])}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="form-group">
                    <label style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                      Image du projet
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      style={{ width: '100%', height: '40px', padding: '8px' }}
                      onChange={(e) => setImage(e.target.files[0])}
                    />
                  </div>
                </Col>
              </Row>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
                <Button size="large" onClick={handlePrevious}>
                  Précédent
                </Button>
                <Button type="primary" size="large" htmlType="submit">
                  Modifier le projet
                </Button>
              </div>
            </div>
          )}
        </form>
      </Modal>

      {/* Modal pour afficher les détails */}
      <Modal
        title={
          <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            <EyeOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
            Détails du projet
          </div>
        }
        visible={isViewModalVisible}
        onCancel={() => setIsViewModalVisible(false)}
        width={900}
        footer={null}
        style={{ top: 20 }}
      >
        {viewingProjet && (
          <div>
            <Steps current={step - 1} style={{ marginBottom: '30px' }}>
              <Step title="Informations générales" />
              <Step title="Impacts & Détails" />
            </Steps>

            {step === 1 && (
              <div>
                <Card style={{ marginBottom: '20px' }}>
                  <Row gutter={[24, 16]}>
                    <Col span={24}>
                      <h3 style={{ color: '#1890ff', marginBottom: '16px' }}>
                        <ProjectOutlined style={{ marginRight: '8px' }} />
                        {viewingProjet?.titre}
                      </h3>
                    </Col>
                  </Row>

                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                        <strong style={{ color: '#666' }}>Zone d'exécution:</strong>
                        <p style={{ marginTop: '8px', marginBottom: 0 }}>
                          {viewingProjet?.zoneExecution || 'Non spécifiée'}
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                        <strong style={{ color: '#666' }}>Budget:</strong>
                        <p style={{ marginTop: '8px', marginBottom: 0, fontSize: '16px', fontWeight: 'bold', color: '#52c41a' }}>
                          {viewingProjet?.budget ? `${parseInt(viewingProjet.budget).toLocaleString()} FCFA` : 'Non défini'}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={[24, 16]} style={{ marginTop: '16px' }}>
                    <Col span={12}>
                      <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                        <strong style={{ color: '#666' }}>Date de début:</strong>
                        <p style={{ marginTop: '8px', marginBottom: 0 }}>
                          <CalendarOutlined style={{ marginRight: '4px' }} />
                          {viewingProjet?.calendrierDebut || 'Non définie'}
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                        <strong style={{ color: '#666' }}>Date de fin:</strong>
                        <p style={{ marginTop: '8px', marginBottom: 0 }}>
                          <CalendarOutlined style={{ marginRight: '4px' }} />
                          {viewingProjet?.calendrierFin || 'Non définie'}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: '16px' }}>
                    <Col span={24}>
                      <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                        <strong style={{ color: '#666' }}>Description du projet:</strong>
                        <p style={{ marginTop: '8px', marginBottom: 0, lineHeight: '1.6' }}>
                          {viewingProjet?.description || 'Aucune description disponible'}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Card>

                <div style={{ textAlign: 'right' }}>
                  <Button type="primary" size="large" onClick={handleNext}>
                    Voir les impacts et détails
                  </Button>
                </div>
              </div>
            )}

            {step === 2 && (
              <div>
                <Card title="Impacts du projet" style={{ marginBottom: '20px' }}>
                  <Row gutter={[24, 16]}>
                    <Col span={8}>
                      <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#e6f7ff', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>💰</div>
                        <strong style={{ color: '#1890ff' }}>Impact économique</strong>
                        <p style={{ marginTop: '8px', fontSize: '12px' }}>
                          {viewingProjet?.impactEconomique || 'Non défini'}
                        </p>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#f6ffed', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>🌱</div>
                        <strong style={{ color: '#52c41a' }}>Impact environnemental</strong>
                        <p style={{ marginTop: '8px', fontSize: '12px' }}>
                          {viewingProjet?.impactEnvironnemental || 'Non défini'}
                        </p>
                      </div>
                    </Col>
                    <Col span={8}>
                      <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#fff2e8', borderRadius: '8px' }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>👥</div>
                        <strong style={{ color: '#fa8c16' }}>Impact social</strong>
                        <p style={{ marginTop: '8px', fontSize: '12px' }}>
                          {viewingProjet?.impactSocial || 'Non défini'}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Card>

                <Row gutter={[24, 24]}>
                  <Col span={12}>
                    <Card size="small" title="🎯 Objectifs">
                      <p style={{ lineHeight: '1.6' }}>
                        {viewingProjet?.objectifs || 'Aucun objectif défini'}
                      </p>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card size="small" title="👥 Bénéficiaires">
                      <p style={{ lineHeight: '1.6' }}>
                        {viewingProjet?.beneficiaires || 'Aucun bénéficiaire défini'}
                      </p>
                    </Card>
                  </Col>
                </Row>

                <Row gutter={[24, 24]} style={{ marginTop: '16px' }}>
                  <Col span={12}>
                    <Card size="small" title="🤝 Partenaires">
                      <p style={{ lineHeight: '1.6' }}>
                        {viewingProjet?.partenaires || 'Aucun partenaire défini'}
                      </p>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card size="small" title="📅 Informations">
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div>
                          <strong>Date de création:</strong>
                          <span style={{ marginLeft: '8px' }}>
                            {viewingProjet?.created || 'Non disponible'}
                          </span>
                        </div>
                        <div>
                          <strong>Statut:</strong>
                          <Tag
                            color={viewingProjet?.actif ? "success" : "warning"}
                            style={{ marginLeft: '8px' }}
                          >
                            {viewingProjet?.actif ? "Validé" : "En attente"}
                          </Tag>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
                  <Button size="large" onClick={handlePrevious}>
                    Retour aux informations générales
                  </Button>
                  <Button type="primary" size="large" onClick={() => setIsViewModalVisible(false)}>
                    Fermer
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </Modal>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default DetailProjets;
